// extracted by mini-css-extract-plugin
export default {"inputRoot":"AutocompleteSearchInput_inputRoot__BmqaJ","clearIndicator":"AutocompleteSearchInput_clearIndicator__yaiyr","paper":"AutocompleteSearchInput_paper__GtfT7"};